<small
  *ngIf="formCtrl.errors?.email && (formCtrl.dirty || formCtrl.touched)"
  class="p-invalid"
>
  {{ errorMsg }}
</small>
